var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.352 16.109-3.456.017a10.08 10.08 0 0 1-2.77 7.694c-3.838 4.006-10.214 4.147-14.212.314-3.998-3.833-4.129-10.208-.291-14.214 3.838-4.004 10.213-4.146 14.212-.313.154.147.292.307.437.463l-2.352.042c-1.352.006-2.35 1.786-2.31 2.72l7.261-.036 2.636-.014-.12-2.805-.296-6.97c-.93.004-2.576 1.002-2.519 2.363l.09 2.196c-.145-.152-.28-.312-.433-.458-5.374-5.151-13.942-4.964-19.1.42-5.16 5.383-4.985 13.954.39 19.105 5.375 5.152 13.943 4.963 19.1-.42a13.545 13.545 0 0 0 3.733-10.104",
    fill: "#262626",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionRefresh);
export default __webpack_public_path__ + "static/media/navigation-and-action-refresh.7f0cbebe.svg";
export { ForwardRef as ReactComponent };